import type { BaseItemSchema, SkillTypes } from "@memorang/types";
import MultipleChoiceReading from "@memorang/ui/components/StudySession/SessionContent/item-types/MultipleChoiceReading";
import { useDevice } from "@memorang/ui/useDevice";
import HintContainer from "../../../containers/HintContainer";
import StudySessionFeedbackContainer from "../../../containers/StudySessionFeedbackContainer";
import useChoiceInteraction from "../../../hooks/useChoiceInteraction";

type Props = {
	item: BaseItemSchema;
	isSplitLayout: boolean;
};

const MultipleChoiceContainer = ({ item, isSplitLayout }: Props) => {
	const { isDesktopWeb } = useDevice();
	const { content, response } = item;

	const {
		choices,
		correctAnswerIds,
		numChoicesRequired,
		isMultiSelect,
		isAnswered,
		isSummativeTest,
		inReviewMode,
		selectedChoiceIds,
		handleSelectChoice,
	} = useChoiceInteraction(item);

	const stimulusText =
		content.stimulus?.type === "TEXT"
			? (content.stimulus.text ?? undefined)
			: undefined;
	const stem = content.stem?.text ?? "";
	const instruction =
		response.type === "OPTION_SELECTION" ? (response.instruction ?? "") : "";
	const shuffle =
		response.type === "OPTION_SELECTION" ? (response.shuffle ?? false) : false;

	const renderFeedback = isDesktopWeb
		? () => <StudySessionFeedbackContainer isSplitLayout={isSplitLayout} />
		: undefined;

	const skill: SkillTypes = item.metadata?.skill ?? "READING";

	return (
		<MultipleChoiceReading
			stimulusText={stimulusText}
			stem={stem}
			instruction={instruction}
			skill={skill}
			choices={choices}
			itemId={item.id!}
			selectedChoiceIds={selectedChoiceIds}
			correctAnswerIds={correctAnswerIds}
			isAnswered={isAnswered}
			isSummativeTest={isSummativeTest}
			inReviewMode={inReviewMode}
			multiSelect={isMultiSelect}
			numChoicesRequired={numChoicesRequired}
			handleSelectChoice={handleSelectChoice}
			shuffle={shuffle}
			renderFeedback={renderFeedback}
			renderHint={
				isAnswered || isSummativeTest
					? undefined
					: () => <HintContainer key={item.id} item={item} />
			}
		/>
	);
};

export default MultipleChoiceContainer;
